import { FC, useState } from "react";

import { copy } from "shared/assets";
import { Move } from "shared/assets/icons";
import { Tooltip } from "shared/components";
import { Icon } from "shared/styles";
import { StyledDragAndDropButton } from "./styles";

const dndCopy = copy.a11y.drag;

export const DragAndDropButton: FC = () => {
  const [referenceElement, setReferenceElement] = useState<Element | null>();

  return (
    <>
      <Tooltip
        content={dndCopy}
        referenceElement={referenceElement}
        maxWidth={200}
      />
      <StyledDragAndDropButton ref={setReferenceElement}>
        <Icon as={Move} size="xl" />
      </StyledDragAndDropButton>
    </>
  );
};
